// extracted by mini-css-extract-plugin
export default {"flex":"ExportWarehouse_flex__rMd1q","title":"ExportWarehouse_title__UBzNx","input_text":"ExportWarehouse_input_text__-S3-K"};